import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Dashboard from "./Pages/Dashboard/Dashboard";
import Timecards from "./Pages/Timecards/Timecards";
import Adjustments from "./Pages/Adjustments/Adjustments";
import Login from "./Pages/Login/Login";
import SelectedReports from "./Pages/SelectedReports/SelectedReports";
import Audit from "./Pages/Audit/Audit";
import { Provider } from "react-redux";
import store from "./redux/store";
import Masterfile from "./Pages/MasterFile/MasterFile";
import Cookies from "js-cookie";
import AdminDash from "./Pages/Dashboard/AdminDash";
import Utilities from "./Pages/Utilities/Utilities";
import PreviewReview from "./Pages/PreviewReview/PreviewReview";
import PayrollChecklist from "./Pages/PayrollChecklist/PayrollChecklist";
import PayrollHours from "./Pages/PayrollHoursAudit/PayrollHours";
import ActivityLog from "./Pages/ActivityLog/ActivityLog";
import UserManagementPage from "./Pages/UserManagement/UserManagement";
import updatecredentialGrid from "./Pages/UpdateCredentialsGrid/updateCredentialsGrid";
import Moniter from "./Pages/Moniter/Moniter";
import HealthInsurance from "./Pages/HealthInsurance/HealthInsurance";
import { AdminRoute, UserRoute, TimecardFollowupRoute } from "./Auth/ProtectedRoutes";
import Garnishments from "./Pages/Garnishments/Garnishments";
import NewHires from "./Pages/NewHires/NewHires";
import OffCyclePage from "./Pages/OffCycle/OffCycle";
import ContingentExpenseManagement from "./Pages/ExpenseManagement/ContingentExpense";
import CorporateExpenseManagement from "./Pages/ExpenseManagement/CorporateExpense";
import ExpenseManagement from "./Pages/ExpenseManagement/ExpenseMain";
import GlCodes from "./Components/ExpenseManagement/GlCodes";
import Graph from "./Pages/Analytics/Graphs";
import FinalMasterAudit from "./Pages/FinalMasterAudit/FinalMasterAudit";
import TimesheetTeam from "./Pages/TimecardFollowup/TimesheetTeam";
import ClientServices from "./Pages/TimecardFollowup/ClientServices";
import EmployeeCare from "./Pages/TimecardFollowup/EmployeeCare";
import CalendarView from "./Pages/CalenderView/CalendarView";

const ProjectRoutes = () => {

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Router forceRefresh={true}>
        <Provider store={store}>
          <Route exact path="/" component={Login} />
          <UserRoute exact path="/dashboard" component={Dashboard} />
          <AdminRoute
            exact
            path="/admin-dashboard"
            component={AdminDash}
          />
          <Route
            exact
            path='/timesheetteam'
            component={TimesheetTeam}
          />
          <Route
            exact
            path='/clientservices'
            component={ClientServices}
          />
          <Route
            exact
            path='/employeecare'
            component={EmployeeCare}
          />
          <UserRoute exact path="/timecards" component={Timecards} />
          <UserRoute exact path="/adjustments" component={Adjustments} />
          <UserRoute exact path="/masterfile" component={Masterfile} />
          <UserRoute exact path="/audit" component={Audit} />
          <UserRoute exact path="/selectedreports" component={SelectedReports} />
          <UserRoute exact path="/utilities" component={Utilities} />
          <UserRoute exact path="/preview" component={PreviewReview} />
          <UserRoute exact path="/payrollchecklist" component={PayrollChecklist} />
          <UserRoute exact path="/payrollhoursaudit" component={PayrollHours} />
          <UserRoute exact path="/activitylog" component={ActivityLog} />
          <UserRoute exact path="/healthinsurance" component={HealthInsurance} />
          <UserRoute exact path="/updatecredentialGrid" component={updatecredentialGrid} />
          <UserRoute exact path="/garnishments" component={Garnishments} />
          <UserRoute exact path="/finalmasteraudit" component={FinalMasterAudit} />
          <UserRoute exact path="/newhiresrehires" component={NewHires} />
          <UserRoute exact path="/offcycle" component={OffCyclePage} />
          <UserRoute exact path="/moniter" component={Moniter} />
          <AdminRoute
            exact
            path="/usermanagement"
            component={UserManagementPage}
          />
          <UserRoute exact path="/contingentexpensemanagement" component={ContingentExpenseManagement} />
          <UserRoute exact path="/corporateexpensemanagement" component={CorporateExpenseManagement} />
          <UserRoute exact path="/expensemanagement" component={ExpenseManagement} />
          <UserRoute exact path="/glcodes" component={GlCodes} />
          <UserRoute exact path="/analytics" component={Graph} />
          <UserRoute exact path="/calendarview" component={CalendarView} />
        </Provider>
      </Router>
    </div>
  );
};
export default ProjectRoutes;